import { render, staticRenderFns } from "./OrgRecShareList.vue?vue&type=template&id=e2ada6ac&scoped=true"
import script from "./OrgRecShareList.vue?vue&type=script&lang=js"
export * from "./OrgRecShareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ada6ac",
  null
  
)

export default component.exports